import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class SymbolsLeftStore {
  root;
  symbolsLeft = 1250;
  symbolsUsed = 0;
  symbolsLeftSubject;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.symbolsLeftSubject = groupByFunction(
      'messageType',
      'symbolsLeft',
      this.root.websocketSubject
    ).subscribe((msg) => this.setSymbolsLeft(msg.symbolsUsed, msg.symbolsLeft));
  };

  setSymbolsLeft = (symbolsUsed, symbolsLeft) => {
    this.symbolsUsed = symbolsUsed;
    this.symbolsLeft = symbolsLeft;
  };
}
